import { Trans } from '@lingui/react/macro'
import gql from 'graphql-tag'
import React, { Component } from 'react'
import { Loading } from './loading'
import { Button, Card } from '@tecsinapse/cortex-react'
import { MdOutlineSentimentDissatisfied } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { logger } from '../utils/logger'
import { useQuery } from '@apollo/client'

const OPS_QUERY = gql`
  query OpsQuery {
    menuUsuarioLogado {
      linkHelpTec
    }
  }
`

export const OpsErrorMessage = () => {
  const { data, loading, error } = useQuery(OPS_QUERY, {
    fetchPolicy: 'cache-first'
  })

  if (loading) {
    return <Loading />
  }

  return (
    <div>
      <Card className={'flex flex-col space-y-mili items-center'}>
        <MdOutlineSentimentDissatisfied size={48} />
        <p className={'text-h1'}>Ops</p>
        <div className={'flex flex-row items-center space-x-mili'}>
          <p className={'text-h4'}>
            <Trans>
              Ocorreu um erro ao processar sua solicitação. Por favor, tente
              novamente. Persistindo o problema abra ticket no
            </Trans>
          </p>
          {error || !data || !data.menuUsuarioLogado ? (
            ' HelpTec'
          ) : (
            <Link
              href={data.menuUsuarioLogado.linkHelpTec}
              className={'text-secondary-medium'}
            >
              HelpTec
            </Link>
          )}
        </div>

        <Button onClick={() => window.history.back()}>
          <Trans>Voltar</Trans>
        </Button>
      </Card>
    </div>
  )
}

export class OpsErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    logger.error({
      message: error.message,
      stack: error.stack
    })
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return <OpsErrorMessage />
    }

    return children
  }
}
